import { addDatadogRumAction } from './datadogRum';
export var BetaEstabAction;
(function (BetaEstabAction) {
    BetaEstabAction["VIEW_MORE_FLIGHTS"] = "View More Flights";
    BetaEstabAction["CHANGE_FLIGHT"] = "Change Flight";
    BetaEstabAction["CHANGE_FLIGHT_ERROR"] = "Change Flight Error";
    BetaEstabAction["AVAILABILITY_ERROR_ROOMS"] = "Availability Error Rooms";
    BetaEstabAction["AVAILABILITY_ERROR_BASKET_SUMMARY"] = "Availability Error Basket Summary";
    BetaEstabAction["AVAILABILITY_ERROR_NO_FLIGHT_IN_TRIP"] = "Availability Error No Flight In Trip";
    BetaEstabAction["AVAILABILITY_ERROR_NO_FLIGHT"] = "Availability Error No Flight";
    BetaEstabAction["AVAILABILITY_NO_ROOMS"] = "Availability No Rooms";
    BetaEstabAction["CTB"] = "CTB";
    BetaEstabAction["CTB_ERROR"] = "CTB Error";
    BetaEstabAction["CTB_ERROR_CACHED_NAVL"] = "CTB Error Cached Navl";
    BetaEstabAction["ROOMS_MISSING_AVAILABILITY"] = "Rooms Missing Availability";
})(BetaEstabAction || (BetaEstabAction = {}));
export function trackBetaEstabAction(action, tripType, tags) {
    addDatadogRumAction(`HC Beta Estab ${action}`, Object.assign(Object.assign({}, tags), { tripType }));
}
// Update to include.
export function trackBetaEstabActionRetry(action, tripType, tags) {
    addDatadogRumAction(`HC Estab Retry ${action}`, Object.assign(Object.assign({}, tags), { tripType }));
}
export function trackBetaEstabActionRetrySuccess(action, tripType, tags) {
    addDatadogRumAction(`HC Estab Successful Retry ${action}`, Object.assign(Object.assign({}, tags), { tripType }));
}
